import Vue from "vue";
import Vuetify from "vuetify/lib/framework";

Vue.use(Vuetify);

export default new Vuetify({
  rtl: true,
  theme: {
    options: { customProperties: true },
    themes: {
      // light: true,
      light: {
        primary: "#22a7ab",
        accent: "#f7f9fc",
        secondary: "#065559",
        success: {
          base: "#22ab60",
          lighten5: "#dcffec",
        },
        error: "#f44336",
        gray: "#909ab0",
        black: "#142140",
        yellow: "#FFC700",
      },
    },
  },
});
